module.exports = __webpack_public_path__ + "img/video.3e796b91.png";